/* global React, Icon */

function Problem() {
  const t = (k) => window.i18n.t(k);

  const quotes = () => [
    {
      text: t("problem.quote.1.text"),
      name: t("problem.quote.1.name"),
      sub: t("problem.quote.1.sub"),
    },
    {
      text: t("problem.quote.2.text"),
      name: t("problem.quote.2.name"),
      sub: t("problem.quote.2.sub"),
    },
    {
      text: t("problem.quote.3.text"),
      name: t("problem.quote.3.name"),
      sub: t("problem.quote.3.sub"),
    },
  ];

  return (
    <section className="section" id="problem">
      <div className="container">
        <div className="problem-head">
          <div>
            <span className="eyebrow">{t("problem.eyebrow")}</span>
            <h2 style={{ marginTop: 16 }}>
              {t("problem.h2.pre")} <span className="hl">{t("problem.h2.hl")}</span>{" "}
              {t("problem.h2.post")}
            </h2>
          </div>
          <p>{t("problem.lede")}</p>
        </div>
        <div className="quote-grid">
          {quotes().map((q, i) => (
            <figure className="quote-card" key={i}>
              <div className="q-mark">“</div>
              <p>{q.text}</p>
              <figcaption className="who">
                <div className="ava">{q.name.split(",")[0].slice(-1).toUpperCase() || "П"}</div>
                <div className="who-text">
                  <div className="nm">{q.name}</div>
                  <div className="sub">{q.sub}</div>
                </div>
              </figcaption>
              {/*
                Бейдж «placeholder · заменить» убран: он рисовался поверх каждой
                карточки-цитаты на проде и читался как подпись автора отзыва,
                то есть социальное доказательство выглядело сфабрикованным.
                Вернётся вместе с реальной атрибуцией цитат, если она появится.
              */}
            </figure>
          ))}
        </div>
        <div className="leak-bar">
          <div className="lb-l">
            <div className="lb-icon">
              <Icon name="warning" size={24} color="#fff" stroke={1.8} />
            </div>
            <div>
              <h3>{t("problem.leak.h3")}</h3>
              <p>{t("problem.leak.p")}</p>
            </div>
          </div>
          <div className="lb-stat">{t("problem.leak.stat")}</div>
        </div>
      </div>
    </section>
  );
}

window.Problem = Problem;
